import React, { useMemo, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Rnd } from 'react-rnd';
import { getTempState, setTempState, useProjectState, useTempState } from '@starflow/app/store';
import { getElementInfoPanelComponents } from '@starflow/app/helpers/component';

export const ElementInfoPanelInner = ({ elementId }) => {
  const renderedComponents = useMemo(() => {
    return getElementInfoPanelComponents().map(({ Component }, index) => (
      <Component key={index} elementId={elementId} />
    ));
  }, [elementId]);

  return renderedComponents;
};

export const ElementInfoPanel = (props) => {
  const elementInfoPanelId = useTempState('elementInfoPanelId');
  const selection = useProjectState('selection');

  useEffect(() => {
    // 选区发生变化时关闭面板
    setTempState({ elementInfoPanelId: null });
  }, [selection]);

  if (!elementInfoPanelId) return null;

  const { left = 0, top = 0 } = getTempState('elementInfoPanelOffset') || {};

  const rightGap = window.innerWidth - left;
  const positionX = rightGap > 310 ? left : window.innerWidth - 310;
  const position = { x: positionX, y: top || 105 };
  const maxHeight = window.innerHeight - 100;

  return createPortal(
    <Rnd
      scale={1}
      bounds={document.body}
      default={position}
      className="z-[100] imginfo-window"
      dragHandleClassName="sub-drag-handle"
    >
      <div
        style={{ maxHeight }}
        className="flex flex-col items-stretch w-[300px] bg-white rounded-[2px] shadow-light pointer-events-auto"
      >
        <ElementInfoPanelInner elementId={elementInfoPanelId} />
      </div>
    </Rnd>,
    document.body,
  );
};
